export default "__VITE_ASSET__DGvNzQmH__"